import { FlightSubLOBProps } from "components/flexComponents/WizardFlightPWA/typings";
import * as React from "react";
import { FlightAddHotelCheckbox } from "components/flexComponents/WizardFlightPWA/components/FlightAddHotelCheckbox";
import { observer } from "mobx-react";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { FlightsFareCalendar } from "./FlightsFareCalendar";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import {
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutConditionalGridSpan,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { LobErrorSummary } from "src/components/shared/LobErrorSummary/LobErrorSummary";

export const OnewayFlight = observer((props: FlightSubLOBProps) => {
  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 2, medium: 12 };
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 8 };
  const datesColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const datesColSpanFH: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const fareCalendarTest = "PWA_fare_calendar_home_page";

  const {
    errorInputRef,
    isOnewayFormValid,
    numberOfErrors,
    moreThanOneError,
    updateInvalidFormsState,
  } = props.lobState;

  if (isOnewayFormValid) {
    updateInvalidFormsState();
  }

  return (
    <UitkLayoutGrid columns={mainGridColumns} space="three" className="all-t-margin-two">
      {!isOnewayFormValid && (
        <LobErrorSummary
          locHeadingToken={props.getLocError(false)!}
          locHeadingArgs={moreThanOneError() && [numberOfErrors]}
          locLinkToken={props.getLocError(true)}
          linkClickFocusId="roundtrip-error"
          inputErrorRef={errorInputRef}
          colSpan={mainGridColumns}
          setInputsRefs={props.setInputsRefs}
        />
      )}
      <Location
        setInputsRefs={props.setInputsRefs}
        originField={true}
        destinationField={true}
        lobState={props.lobState}
        showSwapLocationsControl={true}
        colSpan={locationColSpan}
      />
      <Experiment name={fareCalendarTest}>
        <ExperimentControl>
          <Dates
            singleDate={true}
            lobState={props.lobState}
            colSpan={datesColSpan}
            setInputsRefs={props.setInputsRefs}
          />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <FlightsFareCalendar
            singleDate={true}
            lobState={props.lobState}
            colSpan={datesColSpan}
            setInputsRefs={props.setInputsRefs}
          />
        </ExperimentVariant>
      </Experiment>
      {props.lobState.config.enableAddHotel && (
        <UitkLayoutGridItem colSpan="all">
          <UitkLayoutFlex space="three" className="all-t-padding-two">
            <FlightAddHotelCheckbox flightWizardState={props.lobState} />
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
      )}
      {props.lobState.config.enableAddHotel && props.lobState.isAddAHotelChecked && (
        <Dates
          lobState={props.lobState}
          isPartialStay={true}
          colSpan={datesColSpanFH}
          setInputsRefs={props.setInputsRefs}
        />
      )}
    </UitkLayoutGrid>
  );
});
